import { TMouseEvent, TObject, getStorage } from 'forstok-ui-lib';

import { TUser } from '../../types/share';

export const setEvScrollDown = () => {
  const refScrollContainerEl = document.querySelectorAll('._refChatMessageContainer') as NodeListOf<HTMLDivElement>;
  for (let i = 0; i < refScrollContainerEl.length; i++) {
    const el = refScrollContainerEl[i] as HTMLDivElement
    const childEl = refScrollContainerEl[i].childNodes[0] as HTMLElement
    if (childEl.scrollHeight > el.clientHeight) {
      el.scrollTo({
          top: childEl.scrollHeight, 
          behavior: 'smooth'});
    }
  }
}

export const evPostAI = async (params: TObject) => {
  const users: TUser | undefined = getStorage('users', 'object');
  let parseData: TObject = {
    "user_id": users?.id ? users.id.toString() : '',
    "seller_profile_id": users?.profile_id || 0,
    "channel_id": params?.channelId || 0,
    "seller_store_id": params?.storeId || 0,
    "message": params?.message || ''
  }
  if ('listingId' in params && params.listingId) {
    parseData.listing_id = params.listingId
  }
  const response = await fetch('https://forstok-ai-agent-826410524453.us-central1.run.app/chat', {
    method: 'POST',
    body: JSON.stringify(parseData),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const res = await response.json();
  return res.response;
}

export const evFeedbackAI = (params: TObject) => {
  const users: TUser | undefined = getStorage('users', 'object');
  let parseData: TObject = {
    "user_id": users?.id ? users.id.toString() : '',
    "seller_profile_id": users?.profile_id || 0,
    "channel_id": params?.channelId || 0,
    "seller_store_id": params?.storeId || 0,
    "message": params?.question || '',
    "bot_response": params?.message || '',
    "user_revision": params?.update || ''
  }
  if ('listingId' in params && params.listingId) {
    parseData.listing_id = params.listingId
  }
  const response = fetch('https://forstok-ai-agent-826410524453.us-central1.run.app/feedback', {
    method: 'POST',
    body: JSON.stringify(parseData),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const res = response;
  return res;
}

export const zeroFill = (number: number, width: number) => {
  width -= number.toString().length;
  if (width > 0) {
    return new Array( width + (/\./.test(number.toString()) ? 2 : 1) ).join( '0' ) + number;
  }
  return number + '';
}

export const getAnswer = (parseData: any, storeId: number) => {
  let result = ''
  if (parseData && parseData?.length) {
    const answerIdx = parseData.findIndex((ans: any) => ans.storeId === storeId);
    if (answerIdx >= 0) {
      result = parseData[answerIdx].value;
    }
  }
  return result;
}

export const evElipsis = (value: string, max: number) => {
  const lengthChar = value.length <= max ? value.length : max;
  return value.substring(0, lengthChar) + (value.length > max ? '...' : '');
}

export const isDesktopChat = () => {
  return document.body.clientWidth >= 1280 ? true : false;
}

export const evCompareCacheListing = (existing: any, incoming: any, args: any, readField: any) => {
  let result = true
  // console.log(args, "args", existing, incoming)
  if (incoming?.edges && existing?.edges) {
    if (incoming.edges.length === existing.edges.length) {
      let BreakException = {}
      try {
        console.group("cache", args)
        existing.edges.forEach((listing: any, idx: number) => {
          const _listing = readField("node", listing)
          const _id = readField("id", _listing)
          const _variants = readField("variants", _listing)
          const listingInc = incoming.edges[idx]
          const _listingInc = readField("node", listingInc)
          const _idInc = readField("id", _listingInc)
          const _variantsInc = readField("variants", _listingInc)
          console.log(_id, "(existing)" , "=", _idInc, "(incoming)", "listing.id")
          if (_id !== _idInc) throw BreakException
          if (_variants?.length === _variantsInc?.length) {
            _variants.forEach((variant: any, variantIdx: number) => {
              const _id = readField("id", variant)
              const _idInc = readField("id", _variantsInc[variantIdx])
              console.log(_id, "(existing)" , "=", _idInc, "(incoming)", "listing.variant.id")
              if (_id !== _idInc) throw BreakException
            })
          } else throw BreakException
        })
        console.groupEnd()
      } catch (e) {
        if (e !== BreakException) {
          throw e
        } else {
          console.warn("different ->", existing, incoming, args)
          result = false
        }
      }
    } else {
      result = false
    }
  }

  return result
}

export const evClickCollapse: TMouseEvent = e => {
  e.persist()
  let collapseButtonEl = (e.target as HTMLButtonElement | HTMLElement).closest('._refCollapseButton') as HTMLButtonElement
  const status = collapseButtonEl.dataset.collapse
  const collapseButtonParentEl = collapseButtonEl.closest('._refCollapse') as HTMLDivElement
  let collapseContainerEl = collapseButtonParentEl.querySelector('._refCollapseContainer') as HTMLDivElement
  const height = collapseContainerEl.clientHeight || 0

  if (status === 'true') {
    collapseContainerEl.classList.add('is-loading')
    collapseContainerEl.style.height = height+'px'
    const timerZero = setTimeout(() => {
      collapseContainerEl.classList.remove('is-loading')
      collapseContainerEl.classList.remove('collapsed')
      clearTimeout(timerZero)
    }, 150)
    collapseButtonEl.setAttribute('data-collapse', 'false')
    collapseButtonEl.innerText = 'Show less'
    collapseButtonEl.classList.add('is-active')
  }
  else {
    collapseContainerEl.classList.add('is-loading')
    collapseContainerEl.style.height = ''
    const timerOne = setTimeout(() => {
      collapseContainerEl.classList.remove('is-loading')
      collapseContainerEl.classList.add('collapsed')
      clearTimeout(timerOne)
    }, 150)
    collapseButtonEl.setAttribute('data-collapse', 'true')
    collapseButtonEl.innerText = 'Show more'
    collapseButtonEl.classList.remove('is-active')
  }
}